// @flow

export const FETCH_FARMS = '@@/hfty-assets/FETCH_FARMS'
export const FETCH_FIELDS = '@@/hfty-assets/FETCH_FIELDS'
export const BORDER_UPLOADED = '@@/hfty-assets/BORDER_UPLOADED'
// Action types
export const SELECT_FARM = 'SELECT_FARM'
export const SELECT_FIELD = 'SELECT_FIELD'
